module.exports = __webpack_public_path__ + "img/wrinkles.14f01a85.webp";